/*
 * Copyright (C) 2016 Bilibili. All Rights Reserved.
 *
 * This file is derived from C++ project libWinTF8 (https://github.com/m13253/libWinTF8)
 * @author zheng qian <xqq@xqq.im>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function checkContinuation(uint8array, start, checkLength) {
    let array = uint8array;
    if (start + checkLength < array.length) {
        while (checkLength--) {
            if ((array[++start] & 0xc0) !== 0x80) return false;
        }
        return true;
    } else {
        return false;
    }
}

function decodeUTF8(uint8array) {
    let out = [];
    let input = uint8array;
    let i = 0;
    let length = uint8array.length;

    while (i < length) {
        if (input[i] < 0x80) {
            out.push(String.fromCharCode(input[i]));
            ++i;
            continue;
        } else if (input[i] < 0xc0) {
            // fallthrough
        } else if (input[i] < 0xe0) {
            if (checkContinuation(input, i, 1)) {
                let ucs4 = ((input[i] & 0x1f) << 6) | (input[i + 1] & 0x3f);
                if (ucs4 >= 0x80) {
                    out.push(String.fromCharCode(ucs4 & 0xffff));
                    i += 2;
                    continue;
                }
            }
        } else if (input[i] < 0xf0) {
            if (checkContinuation(input, i, 2)) {
                let ucs4 = ((input[i] & 0xf) << 12) | ((input[i + 1] & 0x3f) << 6) | (input[i + 2] & 0x3f);
                if (ucs4 >= 0x800 && (ucs4 & 0xf800) !== 0xd800) {
                    out.push(String.fromCharCode(ucs4 & 0xffff));
                    i += 3;
                    continue;
                }
            }
        } else if (input[i] < 0xf8) {
            if (checkContinuation(input, i, 3)) {
                let ucs4 =
                    ((input[i] & 0x7) << 18) |
                    ((input[i + 1] & 0x3f) << 12) |
                    ((input[i + 2] & 0x3f) << 6) |
                    (input[i + 3] & 0x3f);
                if (ucs4 > 0x10000 && ucs4 < 0x110000) {
                    ucs4 -= 0x10000;
                    out.push(String.fromCharCode((ucs4 >>> 10) | 0xd800));
                    out.push(String.fromCharCode((ucs4 & 0x3ff) | 0xdc00));
                    i += 4;
                    continue;
                }
            }
        }
        out.push(String.fromCharCode(0xfffd));
        ++i;
    }

    return out.join('');
}

export default decodeUTF8;
